<template>
    <div class="border rounded-xl w-full p-[16px] flex justify-between items-center font-light">
        <div>
            <h2>{{ item.validator.first_name + " " + item.validator.last_name }}</h2>
            <div class="flex items-center gap-x-[6px] mt-[8px]">
                <p class="font-extralight">Niveau de validation : {{ item.level }}</p>
                <SquarePen :size="16" stroke-width="1.3" @click="updateValidator" class="cursor-pointer"/>
            </div>
        </div>

        <button :disabled="load" @click="removeValidator" class="h-[35px] font-light px-4 border rounded-xl bg-[#3c41e9] text-white flex items-center justify-center">
            <Loader2 v-if="load" class="animate-spin mx-auto"/>
            <span v-if="!load">Supprimer</span>
        </button>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import { Loader2, SquarePen } from 'lucide-vue-next';
export default {
    name: "ValidatorCard",
    components:{Loader2, SquarePen},
    props: ["item"],
    data(){
        return {
            load: false
        }
    },
    methods:{
        removeValidator(){
            this.load = true;
            API.delete(`/validators/${this.item.id}`)
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                this.$emit('child-action');
                Swal.fire({title: 'Succès !',text: 'Validateur supprimé',icon: 'success'})
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.load = false)
        },
        async updateValidator() {
            const inputValue = this.item.level;
            const {value: label} = await Swal.fire({
                title: "Modifier le niveau",
                input: "text",
                inputLabel: "",
                inputValue,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return "Vous devez écrire quelque chose";
                    }
                }
            });
            if(label == inputValue) return;
            API.put("validators/"+this.item.id,{level:label})
                .then((res) => {
                    if (!res.data.status) throw Error(res.data.message);
                    this.$emit('child-action');   
                }).catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'));
        },
    }
}
</script>